import React, { useRef } from "react";
import { X } from "lucide-react";

export default function FilterDrawer({
    isOpen,
    onClose,
    sections = [],
    tempValues,
    setTempValues,
    onApply,
    onClear
}) {
    if (!isOpen) return null;

    // close when clicking overlay
    const handleOverlayClick = () => onClose();

    return (
        <>
            {/* Overlay */}
            <div
                onClick={handleOverlayClick}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: 1500,
                }}
            />

            {/* Drawer */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    width: 360,
                    height: "100vh",
                    backgroundColor: "#fff",
                    boxShadow: "-3px 0 12px rgba(0,0,0,0.1)",
                    zIndex: 2000,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "16px 20px",
                        background: "#F8F9FA",
                        borderBottom: "1px solid #eee"
                    }}
                >
                    <h4 style={{ margin: 0, fontWeight: 600, color: ' #212529', fontFamily: 'Montserrat', fontSize: '14px', fontStyle: 'normal', lineHeight: 'normal' }}>Filter</h4>
                    <button
                        onClick={onClose}
                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Body */}
                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px"
                    }}
                >

                    {sections.map((section, index) => (
                        <div
                            key={index}
                        // style={{ borderBottom: "1px solid #E9ECEF", paddingBottom: 20 }}
                        >
                            <label
                                style={{
                                    fontWeight: 600,
                                    color: "#212529",
                                    fontSize: 14,
                                }}
                            >
                                {section.label}
                            </label>

                            {/* Checkbox section */}
                            {section.type === "checkbox" && (
                                <div style={{ marginTop: 10 }}>
                                    {section.options.map((opt, i) => {
                                        const checked = tempValues[section.key]?.includes(opt);

                                        return (
                                            <label
                                                key={i}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    cursor: "pointer",
                                                    padding: "10px 0",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={checked}
                                                    style={{ opacity: 0, position: "absolute" }}
                                                    onChange={(e) => {
                                                        const list = tempValues[section.key] || [];
                                                        setTempValues((prev) => ({
                                                            ...prev,
                                                            [section.key]: e.target.checked
                                                                ? [...list, opt]
                                                                : list.filter((v) => v !== opt),
                                                        }));
                                                    }}
                                                />

                                                <span
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        borderRadius: 4,
                                                        border: "1.5px solid #212529",
                                                        background: checked ? "#FFEB00" : "#fff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {checked && (
                                                        <svg width="12" height="12" viewBox="0 0 12 12">
                                                            <path
                                                                d="M2 6L4.5 8.5L10 3"
                                                                stroke="#000"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    )}
                                                </span>

                                                <span style={{ fontSize: 14 }}>{opt}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            )}

                            {/* Multi-select dropdown section */}
                            {section.type === "dropdown" && (
                                <div style={{ marginTop: 10 }}>
                                    {section.render && section.render()}
                                </div>
                            )}
                            {/* Search input section */}
                            {section.type === "search" && (
                                <div style={{ marginTop: 10 }}>
                                    <input
                                        type="text"
                                        placeholder={section.placeholder || "Search..."}
                                        value={tempValues[section.key] || ""}
                                        onChange={(e) => {
                                            setTempValues(prev => ({
                                                ...prev,
                                                [section.key]: e.target.value
                                            }));
                                        }}
                                        style={{
                                            width: "100%",
                                            padding: "10px",
                                            borderRadius: "8px",
                                            border: "1px solid #D9D9D9",
                                            fontSize: "14px",
                                            fontFamily: "Montserrat",
                                            outline: "none",
                                        }}
                                    />
                                </div>
                            )}


                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: 16,
                        gap: 12,
                        borderTop: "1px solid #eee"
                    }}
                >
                    <button
                        onClick={onClear}
                        style={{
                            background: "none",
                            border: "none",
                            color: "#000",
                            fontWeight: 600,
                            fontSize: 12
                        }}
                    >
                        Clear
                    </button>

                    <button
                        onClick={onClose}
                        style={{
                            background: "#fff",
                            border: "1px solid #212529",
                            padding: "8px 14px",
                            fontSize: 12,
                            borderRadius: 8,
                            fontWeight: 600
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        onClick={onApply}
                        style={{
                            background: "#212529",
                            border: "none",
                            padding: "8px 14px",
                            color: "#fff",
                            fontSize: 12,
                            borderRadius: 8,
                            fontWeight: 600
                        }}
                    >
                        Filter
                    </button>
                </div>
            </div>
        </>
    );
}